import { isLocalDev } from '@/utils/checkRuntime';

export const CHANGE_PASSWORD_LOCK_TIME_HOURS = 24;
export const REQUEST_CODE_LOCK_TIME = isLocalDev ? 5 : 60;
export const DEFAULT_PAGE_SIZE = 10;


export const WALLET_CONNECT_PROJECT_ID = (process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID as string) || 'e9936da4093ed6a637a2f40535134e26'